module.exports = __webpack_public_path__ + "img/product_44.2339b64.webp";